import FollowUpLMWH from "../../../../src/client/katnh/widgets/FollowUpLMWH.js";
import * as React from 'react';
export default {
  FollowUpLMWH,
  React
};